module.exports = __webpack_public_path__ + "static/media/14_Tablet_Facebook.ef93c909.png";